import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { ClassStoreModel } from './class.model';

export interface ClassState extends EntityState<ClassStoreModel> {}

@Injectable({ providedIn: 'root' })
export class ClassStore extends EntityStore<ClassState, ClassStoreModel, 'id'> {
  constructor() {
    super({
      name: 'classes',
      idKey: 'id',
    });
  }
}
